/**
 * ## cortex:std:safeJsonParse
 * Returns a parsed JSON object or the inserted data.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
export function safeJsonParse<T>(data: any): T {
	try {
		return JSON.parse(data) as T;
		// biome-ignore lint/correctness/noUnusedVariables: suppressed due to migration - should be fixed
	} catch (error) {
		return data;
	}
}
